import { z } from 'zod';
// =========================================================
// Densidades de materiales (catálogo configurable).
//
// Una fila por material. La clave es la identificación lógica de la app
// (snake_case). `codigo_bc` es el N° de producto en Business Central
// (M10-XXXX) — opcional porque hay materiales que no están en BC (agua).
// Usado para conversiones kg ↔ m³ ↔ L: pedido de ensamblado, validación
// cruzada de batches, cálculo de rendimientos.
// =========================================================
export const DensidadMaterialSchema = z.object({
    clave: z.string().min(1).max(60),
    nombre: z.string().min(1).max(100),
    codigo_bc: z.string().max(20).nullable(),
    densidad: z.number().positive(),
    unidad: z.string().max(20),
    notas: z.string().nullable(),
    activo: z.boolean(),
    actualizado_en: z.string(),
    actualizado_por_email: z.string().nullable(),
});
export const ListaDensidadesResponseSchema = z.object({
    densidades: z.array(DensidadMaterialSchema),
});
export const CrearDensidadRequestSchema = z.object({
    clave: z
        .string()
        .trim()
        .min(1)
        .max(60)
        .regex(/^[a-z0-9_]+$/, 'Solo letras minúsculas, dígitos y guion bajo.'),
    nombre: z.string().trim().min(1).max(100),
    codigo_bc: z.string().trim().max(20).nullable().optional(),
    densidad: z.number().positive(),
    unidad: z.string().trim().max(20).default('kg/m³'),
    notas: z.string().trim().max(500).nullable().optional(),
});
export const ActualizarDensidadRequestSchema = z.object({
    nombre: z.string().trim().min(1).max(100).optional(),
    codigo_bc: z.string().trim().max(20).nullable().optional(),
    densidad: z.number().positive().optional(),
    unidad: z.string().trim().max(20).optional(),
    notas: z.string().trim().max(500).nullable().optional(),
    activo: z.boolean().optional(),
});
//# sourceMappingURL=densidades.js.map